const chunkMapping = {
	"129": [
		98129
	],
	"192": [
		46192
	],
	"346": [
		98346
	],
	"589": [
		16589
	],
	"772": [
		93772
	],
	"808": [
		59808
	],
	"811": [
		75192
	],
	"857": [
		40857
	],
	"926": [
		21926
	],
	"972": [
		58972
	]
};
const idToExternalAndNameMapping = {
	"16589": [
		"default",
		"./HrsProChat",
		63430
	],
	"21926": [
		"default",
		"./ScreenShare",
		63430
	],
	"40857": [
		"default",
		"./AudioCall",
		63430
	],
	"46192": [
		"default",
		"./PrimeVhire",
		31984
	],
	"58972": [
		"default",
		"./PrimeChat",
		63430
	],
	"59808": [
		"default",
		"./PrimeBlog",
		92220
	],
	"75192": [
		"default",
		"./PrimeJourney",
		71068
	],
	"93772": [
		"default",
		"./PrimeCode",
		45309
	],
	"98129": [
		"default",
		"./MeetingPage",
		63430
	],
	"98346": [
		"default",
		"./WhiteboardPanel",
		63430
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}